var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLockBigIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 34,
    viewBox: "0 0 27 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.4574 13.7144H4.25742C2.93194 13.7144 1.85742 14.7889 1.85742 16.1144V30.5144C1.85742 31.8398 2.93194 32.9144 4.25742 32.9144H23.4574C24.7829 32.9144 25.8574 31.8398 25.8574 30.5144V16.1144C25.8574 14.7889 24.7829 13.7144 23.4574 13.7144Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.257 13.7143V10.1143C22.257 7.88648 21.372 5.7499 19.7967 4.1746C18.2214 2.59929 16.0848 1.71429 13.857 1.71429C11.6292 1.71429 9.49264 2.59929 7.91733 4.1746C6.34203 5.7499 5.45703 7.88648 5.45703 10.1143V13.7143",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.8572 24.5143C14.52 24.5143 15.0572 23.9771 15.0572 23.3143C15.0572 22.6516 14.52 22.1143 13.8572 22.1143C13.1945 22.1143 12.6572 22.6516 12.6572 23.3143C12.6572 23.9771 13.1945 24.5143 13.8572 24.5143Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLockBigIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/lock_big_icon.4ef543b8c322bc3b06e117c184e58a74.svg";